<script setup>
import MarketingLayout from "@/Layouts/MarketingLayout.vue";
import { useChatwoot } from "@/Composables/useChatwoot.js";

const { openChat } = useChatwoot();
</script>

<template>
  <MarketingLayout
    :menu="true"
    title="Ondersteuning"
  >
    <div class="bg-white py-24 sm:py-32">
      <div class="mx-auto max-w-3xl px-6 lg:px-8">
        <div class="text-center">
          <h2 class="text-base/7 font-semibold text-indigo-600">
            Ondersteuning
          </h2>
          <p class="mt-2 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-6xl">
            Hoe kunnen we helpen?
          </p>
          <p class="mx-auto mt-6 max-w-2xl text-lg font-medium text-pretty text-gray-600 sm:text-xl/8">
            Heeft u een vraag, opmerking of probleem? Wij staan voor u klaar via e-mail of chat.
          </p>
        </div>

        <div class="mt-12 grid gap-6 sm:grid-cols-2">
          <a
            href="mailto:info@besapro.eu"
            class="flex flex-col items-start gap-3 rounded-3xl p-8 ring-1 ring-gray-200 transition hover:ring-indigo-300"
          >
            <h3 class="text-lg font-semibold text-gray-900">
              E-mail
            </h3>
            <p class="text-sm/6 text-gray-600">
              Stuur uw vraag naar onze supportbox en we antwoorden zo snel mogelijk.
            </p>
            <span class="text-sm font-semibold text-indigo-600">info@besapro.eu</span>
          </a>

          <button
            type="button"
            class="flex flex-col items-start gap-3 rounded-3xl p-8 text-left ring-1 ring-gray-200 transition hover:ring-indigo-300"
            @click="openChat"
          >
            <h3 class="text-lg font-semibold text-gray-900">
              Chat
            </h3>
            <p class="text-sm/6 text-gray-600">
              Open de chat in de hoek van het scherm voor een snel antwoord.
            </p>
            <span class="text-sm font-semibold text-indigo-600">Start een gesprek</span>
          </button>
        </div>
      </div>
    </div>
  </MarketingLayout>
</template>
